import * as React from "react";
const SvgSpaceClosed = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...props },
    React.createElement("path", { fill: "currentColor", d: "M22 17.5 12 23 2 17.5v-9L12 14l10-5.5zm0-11L12 12 2 6.5 12 1z" })));
export default SvgSpaceClosed;
//# sourceMappingURL=SpaceClosed.js.map